import { ApIcon } from '@alixpartners/ui-components';

import { ReactChild } from 'react';
import { SnackBodyBaseForm } from './SnackBodyBaseForm';
import './SnackSuccessfulBody.css';

interface Props {
  title?: string;
  message?: ReactChild;
}

export const SnackSuccessfulBody = ({ title, message }: Props) => {
  return (
    <SnackBodyBaseForm
      className="snackinfo-successful"
      title={title}
      message={message}
      icon={<ApIcon iconName="baseline_check_circle_outline" iconColor="#488929" />}
    />
  );
};
